import { render, staticRenderFns } from "./PdpDefault.vue?vue&type=template&id=02770a1b&scoped=true"
import script from "./PdpDefault.vue?vue&type=script&lang=js"
export * from "./PdpDefault.vue?vue&type=script&lang=js"
import style0 from "./PdpDefault.vue?vue&type=style&index=0&id=02770a1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02770a1b",
  null
  
)

export default component.exports